import { render, staticRenderFns } from "./chatAbnormalUser.vue?vue&type=template&id=42edaa90&scoped=true&"
import script from "./chatAbnormalUser.vue?vue&type=script&lang=js&"
export * from "./chatAbnormalUser.vue?vue&type=script&lang=js&"
import style0 from "./chatAbnormalUser.vue?vue&type=style&index=0&id=42edaa90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42edaa90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42edaa90')) {
      api.createRecord('42edaa90', component.options)
    } else {
      api.reload('42edaa90', component.options)
    }
    module.hot.accept("./chatAbnormalUser.vue?vue&type=template&id=42edaa90&scoped=true&", function () {
      api.rerender('42edaa90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/chatAbnormalUser/chatAbnormalUser.vue"
export default component.exports